import React from 'react';
import { Link } from 'react-router-dom';
import { StatusPill } from '../StatusPill';
import { BoltIcon } from '../icons';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';

interface ReportingPausedRoundelProps {
  tooltipAlign?: 'left' | 'center' | 'right' | 'top';
}

export const ReportingPausedRoundel: React.FC<ReportingPausedRoundelProps> = ({
  tooltipAlign = 'right',
}) => {
  const { t } = useTranslation();

  const tooltipContent = (
    <div className="w-[360px] p-4 flex items-start gap-2">
      <BoltIcon width={10} height={15} fill="white" className="mt-0.5 flex-shrink-0" />
      <div className="text-sm font-normal text-white leading-[1.375]">
        {t(TranslationKeyEnum.ReportingPausedTooltipTextPrefix)}{' '}
        <Link to="/help" className="underline font-bold text-white hover:text-white/90">
          {t(TranslationKeyEnum.ContactHills)}
        </Link>{' '}
        {t(TranslationKeyEnum.ReportingPausedTooltipTextSuffix)}
      </div>
    </div>
  );

  return (
    <StatusPill
      variant="yellow"
      label={t(TranslationKeyEnum.ReportingPaused)}
      icon={<BoltIcon width={10} height={14} fill="#5E4003" />}
      tooltip={tooltipContent}
      tooltipAlign={tooltipAlign}
    />
  );
};
